import YYEmpty from './empty'

export default YYEmpty